import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Design, Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Input, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {HighlightedText} from '@mintdata-wsp/wsp/ui/components/text/HighlightedText';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SpaceDesignList.less');
const cx = classnames.bind(styles);

export type ProjectInfo = {
    id:number;
    name:string;
    designs:DesignInfo[];
};

export type DesignInfo = {
    id:number;
    uuid:string;
    projectId?:number;
    name:string;
    projectName?:string;
};

export interface ISpaceDesignListState
{
    searchTerm:string;
    projects:ProjectInfo[];
    filteredProjects:ProjectInfo[];
}

@observer
export class SpaceDesignList extends React.Component<any, ISpaceDesignListState>
{
    @observable
    private _state:ISpaceDesignListState = {
        searchTerm: '',
        get projects():ProjectInfo[]
        {
            const filteredProjects:ProjectInfo[] = [];

            rootState.data.projects.forEach((project:Project) =>
            {
                const designs = [];
                project.designs.forEach((design:Design) =>
                {
                    designs.unshift({
                        id: design.id,
                        uuid: design.uuid,
                        name: design.name,
                        projectId: project.id,
                        projectName: project.name
                    });
                });

                designs.length > 0 && filteredProjects.unshift({
                    id: project.id,
                    name: project.name,
                    designs
                });
            });

            return filteredProjects;
        },
        get filteredProjects():ProjectInfo[]
        {
            if( !this.searchTerm )
                return this.projects;

            let result:Array<ProjectInfo> = [];
            const filterStr:string = this.searchTerm.toLowerCase();

            for( let i:number = 0; i < this.projects.length; i++ )
            {
                if( this.projects[i].name.toLowerCase().includes(filterStr) )
                {
                    result.push(this.projects[i]);
                    continue;
                }

                const designs:Array<DesignInfo> = this.projects[i].designs.filter(
                    (design:DesignInfo) => design.name.toLowerCase().includes(filterStr)
                );

                if( designs.length > 0 )
                {
                    result.push({
                        ...this.projects[i],
                        designs
                    });
                }
            }

            return result;
        }
    };

    @action.bound
    private _handleSearchTermChange(term:string):void
    {
        this._state.searchTerm = term;
    }

    @bind
    private _getDesignSelectHandler(project:ProjectInfo, design:DesignInfo):() => void
    {
        return () => controllers.navigation.toDesign(project.id, design.id);
    }

    render():JSX.Element
    {
        const {filteredProjects, searchTerm} = this._state;

        const selectedDesignUuid = controllers.ui.openDesign.getOpenDesign()
            ? controllers.ui.openDesign.getOpenDesign().designRef.uuid
            : null;

        return (
            <div className={cx('base')}>
                <Input
                    icon={MDIcons.common.Search}
                    placeholder="Search by design name..."
                    className={cx('searchWrapper')}
                    inputClassName={cx('searchInput')}
                    style={InputStyle.Simple}
                    initialValue={searchTerm}
                    isInitiallySelected={true}
                    isInitiallyFocused={true}
                    onChange={this._handleSearchTermChange}
                />
                <div className={cx('searchResults')}>

                    {filteredProjects.map((project:ProjectInfo) => (
                        <div className={cx('projectItem')} key={project.id}>
                            <div className={cx('projectName')}>
                                <HighlightedText text={project.name} partToHighlight={searchTerm} />
                            </div>

                            {project.designs.map((design:DesignInfo) => (
                                <div
                                    className={cx('listItem')}
                                    onClick={this._getDesignSelectHandler(project, design)}
                                    key={design.uuid}
                                >
			                        <span className={cx('iconWrapper')}>
			                            {selectedDesignUuid === design.uuid && <MDIcon
                                            className={cx('icon')}
                                            name={MDIcons.common.Checkmark}
                                            size={MDIconSize.medium16}
                                        />}
			                        </span>
                                    <span className={cx('title')}>
							            {project.name.toLowerCase()
                                            .indexOf((searchTerm || '').trim().toLowerCase()) > -1
                                            ? design.name
                                            :
                                            <HighlightedText text={design.name} partToHighlight={searchTerm} />
                                        }
						            </span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
